import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import * as uaParser from 'ua-parser-js';
import * as uuid from 'uuid';

// note: only import config service, all other modules import log service
import {ConfigService} from './config.service';

declare var window: any;


@Injectable()
export class LogService {
	constructor (
		private http: Http,

		private config: ConfigService
	) {}


	private showInConsole = true;
	private enableDevMessages = true;

	public needPageReLoad = false;
	public originalHref = '';
	public currentPath = '';

	public showFaq = false;

	public showLoadingFilms = false;

	public visitDeviceId = '';
	public visitUserId = '';
	public visitCount = 0;


	// use when continue to re-add console.log debugging messages
	dev(message: any) {
		if (this.enableDevMessages) {
			this.logMessage('dev', message);
		}
	}


	// actions user takes
	action(message: any) {
		this.logMessage('action', message);
	}


	// actions user takes
	perf(message: any, time: number) {
		this.logMessage('perf', message, time);
	}


	// by design functionality, log info that can be used to improve user experience (example, filling out forms with invalid data)
	info(message: any) {
		this.logMessage('info', message);
	}


	// the program is functioning, but these should not happen too often (example, invalid email/password at signin)
	warn(message: any) {
		this.logMessage('warn', message);
	}


	// stuff that should not happen
	error(message: any) {
		this.logMessage('error', message);
	}


	// uncaught exceptions only
	exception(message: any) {
		this.logMessage('exception', message);
	}


// TODO - write this: https://angular.io/docs/ts/latest/api/core/index/ExceptionHandler-class.html

	// stuff that should not happen, that came from outside the app
	windowOnError(message: any) {
		console.log('windowOnError:');
		this.logMessage('error', message);
	}


	private logMessage(logType: string, message: any, theTime = 0) {
		if (this.showInConsole) {
			let msg = logType + ': ' + message;
			if ((logType === 'error') || (logType === 'exception')) {
				console.error(msg);
			} else if (logType === 'warn') {
				console.warn(msg);
			} else if (logType === 'perf') {
				console.log(msg + ', ' + theTime);
			} else {
				console.log(msg);
			}
		}

// TODO - does not work for IE, must throw exception
		let stackLine = '';
		// let stackLine = (new Error).stack.split('\n')[3];
		// let stackLines = (new Error).stack.split('\n');
		let err = new Error();
		// if (err.stack && (err.stack.length > 2) ) {
		if (err.stack) {
			let stackLines = err.stack.split('\n');
			if (stackLines.length > 2) {
				stackLine = stackLines[3];

// TODO - convert *.js to *.ts line number using source map
// https://github.com/mozilla/source-map
			}
		}
		// console.log('stackLine');
		// console.log(stackLine);

		let stackTrace = '';
		if (message instanceof Error) {
			if (message.stack) {
				stackTrace = message.stack;
				message = '' + message;
			}
		}

//    private formatError(arg) {
//       if (arg instanceof Error) {
//         if (arg.stack) {
//           arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
//               ? 'Error: ' + arg.message + '\n' + arg.stack
//               : arg.stack;
//         } else if (arg.sourceURL) {
//           arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
//         }
//       }
//       return arg;
//     }

		let browserUserAgent = '';
		try {
			// browserUserAgent = UaService.browserInfo().ua;

			// let userAgentJson  = (new UAParser()).getResult();
			let userAgentJson  = (new uaParser.UAParser()).getResult();
			// console.log('userAgentJson');
			// console.log(userAgentJson);
			browserUserAgent = JSON.stringify(userAgentJson);
			// console.log('browserUserAgent');
			// console.log(browserUserAgent);
		} catch (ex) {
			console.log('Error: could not get browserUserAgent');		// only log to console, avoid endless loops
			console.log(ex);
		}
		let browserScreenSize = '';
		try {
			let browserScreenSizeObj = {
				screen: {
					width: screen.width,
					height: screen.height
				},
				window: {
					width: window.innerWidth,
					height: window.innerHeight
				},
				document: {
					width: document.documentElement.clientWidth,
					height: document.documentElement.clientHeight
				}
			};
			browserScreenSize = JSON.stringify(browserScreenSizeObj);
		} catch (ex) {
			console.log('Error: could not get browserScreenSize');		// only log to console, avoid endless loops
			console.log(ex);
		}
		let browserPerformance = {};
		try {
			browserPerformance = JSON.stringify(window.performance);
		} catch (ex) {
			console.log('Error: could not get browserPerformance');		// only log to console, avoid endless loops
			console.log(ex);
		}
		let browserDownloadSpeed = '';
		try {
// !!!TODO - add this
			browserDownloadSpeed = '';
		} catch (ex) {
			console.log('Error: could not get browserDownloadSpeed');		// only log to console, avoid endless loops
			console.log(ex);
		}


		let payload = {
			logId: uuid.v4().replace(/-/g, ''),
			logSource: 'ui',
			type: logType,

			message: message || '',
			codeLocation: stackLine || '',
			stackTrace: stackTrace || '',
			// errorSource: errorSource || '',
			time: theTime,

			visitDeviceId: this.visitDeviceId || '',
			visitUserId: this.visitUserId || '',
			visitCount: this.visitCount || 0,

			browserUserAgent: browserUserAgent,
			browserScreenSize: browserScreenSize,
			browserPerformance: browserPerformance,
			browserDownloadSpeed: browserDownloadSpeed
		};

		// console.log('payload');
		// console.log(payload);
		this.createLog(payload);
	}


	getBrowser(): any {
		try {
			// let userAgentJson  = (new UAParser()).getResult();
			let userAgentJson  = (new uaParser.UAParser()).getResult();
			// console.log('userAgentJson');
			// console.log(userAgentJson);
			if (userAgentJson.browser && userAgentJson.browser.name) {
				return userAgentJson.browser.name;
			}
			return '';
		} catch (ex) {
			console.log('Error: could not get userAgentJson');		// only log to console, avoid endless loops
			console.log(ex);
			return '';
		}
	}


	getOs(): any {
		try {
			// let userAgentJson  = (new UAParser()).getResult();
			let userAgentJson  = (new uaParser.UAParser()).getResult();
			// console.log('userAgentJson');
			// console.log(userAgentJson);
			if (userAgentJson.os && userAgentJson.os.name) {
				return userAgentJson.os.name;
			}
			return '';
		} catch (ex) {
			console.log('Error: could not get userAgentJson');		// only log to console, avoid endless loops
			console.log(ex);
			return '';
		}
	}


	getLogs(publicLogEntries = false, internalLogEntries = true, logFilterType = '', logFilterUserId = '') {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/logs?public=' + publicLogEntries + '&internal=' + internalLogEntries + '&type=' + logFilterType + '&userId=' + logFilterUserId, options)
				.toPromise()
				.then((res: any) => {
					resolve(res.json());
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					console.log(err);
					// resolve({});			// TODO - reject with error !!!
				});
		});
	}



	private createLog(payload: any) {
		let accessToken = localStorage.getItem('auth-jwt');
		let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
		headers.append('Content-Type', 'application/json');
		let options = new RequestOptions({ headers: headers });

		let body = JSON.stringify(payload);

		this.http.post(this.config.basePath + '/v0/logs', body, options)
			.toPromise()
			.then((res: any) => {
				// let foo = res.json();
				if (payload.type === 'exception') {
					console.log('Exception logged to db, attempting redirect after exception.');

					this.redirectAfterException();

					// let redirectUrl = location.origin + '/#/site/home';
					// if (location.hash !== '#/site/home') {
					// 	window.location.href = redirectUrl; // condition is required to prevent infinite loop
					// } else {
					// 	console.log('Exception on profile tab, skipping redirect.');
					// }
				}
			})
			.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
				console.log(err);			// only log to console, avoid endless loops
				if (payload.type === 'exception') {
					console.log('Exception NOT logged to db, attempting redirect after exception.');

					this.redirectAfterException();

					// let redirectUrl = location.origin + '/#/site/home';
					// if (location.hash !== '#/site/home') {
					// 	window.location.href = redirectUrl; // condition is required to prevent infinite loop
					// } else {
					// 	console.log('Exception on profile tab, skipping redirect.');
					// }
				}
			});
	}


	private redirectAfterException() {
		// let redirectUrl = location.origin + '/#/site/home';
		// if (location.hash !== '#/site/home') {
		// 	window.location.href = redirectUrl; // condition is required to prevent infinite loop
		// } else {
		// 	console.log('Exception on profile tab, skipping redirect.');
		// }

		// let redirectPath = 'common/profile';
		let redirectPath = 'site/home';
		let redirectUrl = location.origin + '/#/' + redirectPath;

		// console.log('location.hash');
		// console.log(location.hash);

		console.log('this.currentPath');
		console.log(this.currentPath);


		if (this.currentPath !== '/' + redirectPath) {
			console.log('Redirecting to ' + redirectPath);
			window.location.href = redirectUrl; // condition is required to prevent infinite loop
		} else {
			console.log('Skipping redirect to ' + redirectPath + ', already on this tab');
		}
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/log.service.ts